import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { services } from '../../../mocks/home';

const ServicesSection = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-cream" id="services">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="h-0.5 w-8 bg-teal"></div>
            <span className="text-teal font-body text-xs tracking-widest uppercase font-medium">Our Services</span>
            <div className="h-0.5 w-8 bg-teal"></div>
          </div>
          <h2 className="font-heading font-800 text-navy text-4xl lg:text-5xl mb-4">
            Complete Moving Solutions
          </h2>
          <p className="text-charcoal/60 font-body text-lg max-w-xl mx-auto leading-relaxed">
            Every type of move handled with the care, precision, and professionalism that Minneapolis families and businesses depend on.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <Link
              key={service.id}
              to={`/services/${service.id}`}
              className={`group bg-white rounded-2xl p-7 border border-transparent hover:border-teal/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: visible ? `${i * 60}ms` : '0ms' }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-navy/5 group-hover:bg-teal/15 rounded-xl mb-5 transition-colors duration-300">
                <i className={`${service.icon} text-navy group-hover:text-teal text-2xl transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading font-700 text-navy text-lg mb-2">{service.title}</h3>
              <p className="text-charcoal/60 font-body text-sm leading-relaxed mb-4">{service.description}</p>
              <div className="flex items-center gap-1.5 text-teal font-heading font-600 text-sm">
                <span>Learn More</span>
                <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform duration-200"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className={`text-center mt-14 transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <Link
            to="/#quote"
            className="inline-flex items-center gap-2 bg-navy hover:bg-charcoal text-white font-heading font-700 px-8 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-text-line"></i>
            Get a Free Moving Quote
          </Link>
          <p className="text-charcoal/50 font-body text-sm mt-3">No obligation · Transparent pricing · Same-day response</p>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
